export default __webpack_public_path__ + "pgnv-assets/2053d1fa10d2cf6ff29d758adf8cbf46.png";